import { normalizeGroupValue, serializeGroupValue } from './group';

export const buildGroupOptions = (classification) =>
  (classification?.CompetitionDetails?.InGroup || []).map((group) => ({
    name:  group.InGroupName,
    // Use InGroup string (e.g. "RC2") as value — matches engine's InGroup field.
    // Compatible with SP protocol too: SP views are indexed under both GroupListID key
    // AND Group-name key by buildGroupKeys, so '["RC2"]' lookups still find SP data.
    value: normalizeGroupValue(group.Group),
  }));

export const matchGroupValue = (options, currentValue) => {
  if (!options.length) {
    return [];
  }

  const normalizedCurrent = normalizeGroupValue(currentValue);
  const serializedCurrent = serializeGroupValue(normalizedCurrent);

  const matchedOption = options.find(
    (option) => serializeGroupValue(option.value) === serializedCurrent
  );

  return matchedOption ? matchedOption.value : options[0].value;
};

// Przy pierwszym wejściu (brak zapisanego wyboru / nieznaleziony StageID)
// domyślnie pokazujemy najbardziej aktualny odcinek — ostatni, który już
// wystartował (IN_PROGRESS lub FINISHED) — zamiast zawsze OS1. Stages są
// posortowane rosnąco po StageOrder (ApiPage.js), więc ostatni taki od końca
// to zarazem odcinek trwający (jeśli jest) albo ostatni zakończony.
// Jeśli rajd jeszcze się nie zaczął (same NOT_STARTED), wracamy do OS1.
const findDefaultStageIndex = (stages) => {
  for (let i = stages.length - 1; i >= 0; i--) {
    const phase = stages[i]?.TimingPhase;
    if (phase === 'IN_PROGRESS' || phase === 'FINISHED') {
      return i;
    }
  }
  return 0;
};

export const deriveSelectionState = (competitions, selection) => {
  if (!competitions.length) {
    return null;
  }

  let competitionIndex = competitions.findIndex(
    (competition) => competition.IDCompetition === selection.competitionId
  );

  if (competitionIndex < 0) {
    competitionIndex = 0;
  }

  const competition = competitions[competitionIndex];
  const classifications = competition?.Classifications || [];

  let classificationIndex = classifications.findIndex(
    (classification) => classification.ClassificationID === selection.classificationId
  );

  if (classificationIndex < 0) {
    classificationIndex = 0;
  }

  const classification = classifications[classificationIndex];
  const stages = competition?.Stages || [];

  let stageIndex = stages.findIndex((stage) => stage.StageID === selection.stageId);

  if (stageIndex < 0) {
    stageIndex = findDefaultStageIndex(stages);
  }

  const stage = stages[stageIndex];
  const groupOptions = buildGroupOptions(classification);
  const groupValue = matchGroupValue(groupOptions, selection.group);

  return {
    competitionIndex,
    classificationIndex,
    stageIndex,
    groupOptions,
    selectionPayload: {
      eventId: selection.eventId,
      competitionId: competition?.IDCompetition || null,
      competitionName: competition?.NameCompetition || '',
      classificationId: classification?.ClassificationID || null,
      stageId: stage?.StageID || null,
      stageStatus: stage?.StageStatus || null,
      stageStatusDesc: stage?.StageStatusDesc || '',
      stageIsTested: stage?.IsTested || 0,
      group: groupValue,
    },
  };
};
